module.exports = __webpack_public_path__ + "static/media/COS_FOOTER_FIDELITE.d1b529a2.jpg";